// Fila de envio por conversa.
//
// Pedido do Gabriel (Carangola, 10/09/2026): mandar a segunda mensagem sem
// esperar a primeira sair. Antes, `enviar` armava uma trava no começo e só
// soltava depois de assumir a conversa, subir pro servidor (que espera a
// Evolution) e recarregar conversa e lista. Numa internet de loja isso eram
// vários segundos por mensagem com o botão desabilitado — ele digitava a
// próxima e não conseguia mandar.
//
// Agora cada envio entra numa fila da conversa e o campo nunca trava. A fila
// garante as duas coisas que a trava garantia de graça:
//
//   - ORDEM: sai uma de cada vez, na ordem em que foram mandadas. "Boa tarde"
//     e "tem sim" chegando trocados no cliente é pior que chegar devagar.
//   - NADA SE PERDE: se uma falha, a fila DAQUELA conversa para, e a que falhou
//     volta junto com todas que vinham atrás. Mandar a terceira sem a segunda
//     seria sair fora de ordem.
//
// Uma fila por conversa: travar a conversa B porque a A está enviando uma foto
// pesada seria reinventar a trava.
//
// Sem React aqui de propósito — é o pedaço que dá pra testar sozinho
// (backend/test/filaDeEnvio.test.js).

export function criarFilaDeEnvio({ executar, aoFalhar, aoEsvaziar }) {
  const filas = new Map(); // conversaId -> { itens: [], rodando: bool }

  async function drenar(conversaId) {
    const fila = filas.get(conversaId);
    if (!fila || fila.rodando) return;
    fila.rodando = true;
    let falhou = false;
    try {
      while (fila.itens.length) {
        const job = fila.itens[0];
        try {
          await executar(job);
          fila.itens.shift();
        } catch (erro) {
          // Devolve a que falhou E as de trás, na ordem — quem chamou decide
          // como devolver ao atendente (texto de volta no campo).
          const devolvidas = fila.itens.splice(0);
          falhou = true;
          try { aoFalhar?.(conversaId, erro, devolvidas); } catch (_) { /* não derruba a fila */ }
          break;
        }
      }
    } finally {
      fila.rodando = false;
      if (!fila.itens.length) {
        filas.delete(conversaId);
        try { aoEsvaziar?.(conversaId, { falhou }); } catch (_) { /* idem */ }
      } else {
        // Chegou job novo durante o aoFalhar: segue drenando.
        drenar(conversaId);
      }
    }
  }

  return {
    enfileirar(conversaId, job) {
      if (!filas.has(conversaId)) filas.set(conversaId, { itens: [], rodando: false });
      filas.get(conversaId).itens.push(job);
      drenar(conversaId);
    },
    // Quantas ainda vão sair nesta conversa (inclui a que está saindo agora).
    tamanho(conversaId) {
      return filas.get(conversaId)?.itens.length || 0;
    },
  };
}
